import { useCallback, useState, type ReactNode } from 'react'

import { TEST_ID } from '@/src/general/constants/testId'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

import { COMMUNITY_FILTER, EVENT_ORIGIN } from '../../../models/community.constants'
import { useCommunitiesQuery } from '../../../services/useCommunitiesQuery'
import { CommunitiesGrid } from '../../components/CommunitiesGrid'
import { CommunitiesLoadMoreButton } from '../../components/CommunitiesLoadMoreButton'
import { SearchBar } from '../../components/SearchBar'
import { useLimitItem } from '../../hooks/useLimits'

export const CommunitySearch = (): ReactNode => {
  const [searchValue, setSearchValue] = useState('')

  const { limit } = useLimitItem()

  const queryEnabled = searchValue.length > 2
  const communitiesQuery = useCommunitiesQuery({
    filter: COMMUNITY_FILTER.KEYWORD,
    filterParam: searchValue,
    fields: ['lastPublication', 'hasJoined', 'sharesCount'],
    limit,
    meta: ['globalCount', 'hasMore'],
    enabled: queryEnabled,
  })

  const handleChangeText = useCallback(
    (searchStr: string) => {
      setSearchValue(searchStr)
    },
    [setSearchValue],
  )

  return (
    <>
      <SearchBar testID={TEST_ID.COMMUNITIES.SEARCH_INPUT} onChangeText={handleChangeText} searchValue={searchValue} />
      <CommunitiesGrid
        centered={false}
        {...communitiesQuery}
        origin={EVENT_ORIGIN.COMMUNITIES_SEARCH}
        source={TRACKING_SOURCE.COMMUNITIES_SEARCH}
      />
      <CommunitiesLoadMoreButton {...communitiesQuery} />
    </>
  )
}
